export default __webpack_public_path__ + "static/media/july-banner.ab3138e9.svg";